import CommonHeaderInner from "@/components/CommonHeaderInner/CommonHeaderInner";
import Seo from "@/components/Seo/Seo";
import WhatPeopleSay from "@/components/WhatPeopleSay/WhatPeopleSay";
import assest from "@/json/assest";
import Wrapper from "@/layout/wrapper/Wrapper";
import {
  Box,
  Container,
  Grid,
  List,
  ListItem,
  styled,
  Typography,
} from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import React from "react";

const carrerloop: any[] = [
  {
    carrertitle: "Direct Support Professional (DSP)",
    priceIcon: `${assest.priceIcon}`,
    price: "Variable",
    locationIcon: `${assest.locationIcon}`,
    location: "Springfield, Va",
    text: "Responsible for helping individuals with intellectual and developmental disabilities lead richer lives",
  },

];

const CarrerWrapper = styled(Box)`
  .carrerWrapper {
    padding: 80px 0;
    @media (max-width: 599px) {
      padding: 20px 0;
    }
    .carrerHeading {
      text-align: center;
      p {
        font-weight: 400;
        font-size: 16px;
        line-height: 1.5;
        color: #36383a;
        max-width: 756px;
        width: 100%;
        margin: 0 auto 40px;
      }
    }
    .carrerBody {
      .MuiGrid-container {
        justify-content: center;
      }
      .carrerBox {
        background: #ffffff;
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
        border-radius: 10px;
        position: relative;
        padding: 25px 30px;
        margin: 0 0 14px;

        @media (max-width: 599px) {
          padding: 20px;
        }
        &:hover {
          background: #73c2fb;
          h3,
          span,
          p {
            color: #fff;
          }
          img {
            filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(286deg)
              brightness(440%) contrast(323%);
          }
        }
        &::after {
          background: #73c2fb;
          border-radius: 0 0 10px 10px;
          position: absolute;
          z-index: -9;
          bottom: -6px;
          left: 0;
          width: 100%;
          height: 15px;
          content: "";
        }
        h3 {
          font-weight: 500;
          font-size: 22px;
          line-height: 1.5;
          color: #000000;
          margin: 0 0 29px;
          font-family: "Ubuntu", sans-serif;
        }
        ul {
          display: flex;
          align-items: center;
          margin: 0 0 19px;
          padding: 0;
          li {
            display: flex;
            align-items: center;
            margin: 0 20px 0 0;
            padding: 0;
            width: auto;
            img {
              margin-right: 5px;
            }
            span {
              font-weight: 400;
              font-size: 14px;
              line-height: 1.4;
              color: rgba(0, 0, 0, 0.5);
              font-family: "Ubuntu", sans-serif;
            }
          }
        }
        p {
          font-weight: 400;
          font-size: 16px;
          line-height: 2;
          color: #36383a;
          font-family: "Montserrat", sans-serif;
        }
      }
    }
  }
`;

const index = () => {
  return (
    <Wrapper>
      <Seo title="Career" canonical={""} description={""} url={""} image={""} />
      <CarrerWrapper>
        <Box>
          <CommonHeaderInner name="Careers" pageName="Careers" />
        </Box>

        <Box className="carrerWrapper">
          <Container fixed>
            <Box className="carrerHeading">
              <Typography variant="h2" className="cmn-head">
                We are <span>hiring</span>{" "}
              </Typography>
              <p>
                {/* It has survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged. It was
                popularised in the 1960s. */}
                Join our dedicated team to start making a difference.
              </p>
            </Box>

            <Box className="carrerBody">
              <Grid container spacing={2}>
                {carrerloop.map((item, index) => {
                  return (
                    <Grid item md={6} xs={12}>
                      <Link href="/careerdetails">
                        <Box className="carrerBox" key={index}>
                          <Typography variant="h3">
                            {item.carrertitle}
                          </Typography>
                          <List>
                            <ListItem>
                              <Image
                                src={item.priceIcon}
                                width={12}
                                height={12}
                                alt="img"
                              />
                              <span>{item.price}</span>
                            </ListItem>
                            <ListItem>
                              <Image
                                src={item.locationIcon}
                                width={9}
                                height={12}
                                alt="img"
                              />
                              <span>{item.location}</span>
                            </ListItem>
                          </List>
                          <p>{item.text}</p>
                        </Box>
                      </Link>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </Container>
        </Box>

        <Box>
          <WhatPeopleSay />
        </Box>
      </CarrerWrapper>
    </Wrapper>
  );
};

export default index;
